/* ==========================================================================
   UGC Image Reviews (alternate) — Carousel progress bar + drag-to-scroll
   ========================================================================== */
(function () {
  var SECTION_SELECTOR = '.oddit-section-ugc-review-alt';
  var DRAG_THRESHOLD = 5;

  function initProgressBar(section) {
    var cards = section.querySelector('.oddit-section-ugc-review-alt__cards');
    var fill = section.querySelector('.oddit-section-ugc-review-alt__progress-fill');
    var progress = section.querySelector('.oddit-section-ugc-review-alt__progress');
    if (!cards || !fill || !progress) return;

    function update() {
      var scrollWidth = cards.scrollWidth;
      var clientWidth = cards.clientWidth;
      var maxScroll = scrollWidth - clientWidth;

      if (maxScroll <= 0) {
        progress.style.display = 'none';
        return;
      }
      progress.style.display = '';

      var thumbPct = (clientWidth / scrollWidth) * 100;
      var leftPct = (cards.scrollLeft / maxScroll) * (100 - thumbPct);

      fill.style.width = thumbPct + '%';
      fill.style.left = leftPct + '%';
    }

    cards.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initDrag(section) {
    var cards = section.querySelector('.oddit-section-ugc-review-alt__cards');
    if (!cards) return;

    var pointerId = null;
    var startX = 0;
    var startScrollLeft = 0;
    var isDragging = false;
    var didMove = false;

    function onPointerDown(e) {
      if (e.pointerType === 'touch') return;
      pointerId = e.pointerId;
      startX = e.clientX;
      startScrollLeft = cards.scrollLeft;
      isDragging = true;
      didMove = false;
    }

    function onPointerMove(e) {
      if (!isDragging || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      if (!didMove && Math.abs(dx) > DRAG_THRESHOLD) {
        didMove = true;
        cards.classList.add('is-grabbing');
        try { cards.setPointerCapture(pointerId); } catch (err) {}
      }
      if (didMove) {
        cards.scrollLeft = startScrollLeft - dx;
        e.preventDefault();
      }
    }

    function onPointerUp(e) {
      if (e.pointerId !== pointerId) return;
      try { cards.releasePointerCapture(pointerId); } catch (err) {}
      isDragging = false;
      pointerId = null;
      cards.classList.remove('is-grabbing');
    }

    function onClickCapture(e) {
      if (didMove) {
        e.preventDefault();
        e.stopPropagation();
        didMove = false;
      }
    }

    cards.addEventListener('pointerdown', onPointerDown);
    cards.addEventListener('pointermove', onPointerMove);
    cards.addEventListener('pointerup', onPointerUp);
    cards.addEventListener('pointercancel', onPointerUp);
    cards.addEventListener('click', onClickCapture, true);
    cards.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function initSection(section) {
    initProgressBar(section);
    initDrag(section);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
